import { render } from "./pageNav.vue?vue&type=template&id=2547e123&scoped=true"
import script from "./pageNav.vue?vue&type=script&lang=js"
export * from "./pageNav.vue?vue&type=script&lang=js"

import "./pageNav.vue?vue&type=style&index=0&id=2547e123&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\colin\\Documents\\WebProjects\\cee\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2547e123"]])

export default __exports__